module.exports = __webpack_public_path__ + "AbrirRegalo.04aed1bcb9a3a11ee7059b1f7359c3a8.png";